<script>
/* COMPOSANTS */
import GaView from '@components/v2/layout/GaView';
import GaListView from '@components/v2/layout/GaListView.vue';
import AkDatatablePagination from '@components/v2/general/AkDatatablePagination.vue';
import MailTemplateUpdate from '@views/mailtemplate/MailTemplateUpdate.vue';
import {Icon} from '@iconify/vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import messageMixin from '@mixins/messageMixin';
import mailTemplateConst from '@mixins/const/mailTemplateConst';

/* SERVICES */
import mailTemplateService from '@services/mailTemplateService';

export default {
  components: {
    MailTemplateUpdate,
    Icon,
    AkDatatablePagination,
    GaListView,
    GaView,
  },
  mixins: [messageMixin, utilsMixin, mailTemplateConst],
  head() {
    return {
      title: 'settings.mail_template',
    };
  },
  data() {
    return {
      list: [],
      searchValue: undefined,
      loading: true,
      submitted: false,
    };
  },
  computed: {
    listFilter() {
      if (this.list) {
        return this.list.filter(
          (i) =>
            this.searchValue === undefined ||
            i.brevoName?.toLowerCase().includes(this.searchValue?.toLowerCase()) ||
            this.displayForMailTechnicalKeyConst(i?.technicalName)
              ?.toLowerCase()
              .includes(this.searchValue?.toLowerCase()),
        );
      }
      return [];
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.loading = true;
      mailTemplateService.list().then((data) => {
        this.list = data;
        this.loading = false;
      });
    },
    search(value) {
      this.searchValue = value;
    },
    openUpdateSidebar(item) {
      this.$nextTick(() => {
        this.$refs.mailTemplateUpdateSidebar.show(item);
      });
    },
    updateMailTemplate(item) {
      this.list.find((i) => i.id === item.id).technicalName = item.technicalName;
    },
    sortMailTechnicalNameField({technicalName}) {
      return this.technicalKeyConstAlphabetical.findIndex(({value}) => value === technicalName);
    },
  },
};
</script>

<template>
  <GaView>
    <template #content>
      <GaListView searchable @search="search">
        <template #content>
          <AkDatatablePagination :loading="loading" :value="listFilter" :lazy="false">
            <template #empty>
              {{ $t('mail_template.empty') }}
            </template>
            <Column sortable :header="$t('mail_template.name')" field="brevoName" style="min-width: 300px" />
            <Column
              sortable
              :sort-field="sortMailTechnicalNameField"
              :header="$t('mail_template.technical_name')"
              style="min-width: 300px">
              <template #body="{data}">
                {{ displayForMailTechnicalKeyConst(data.technicalName) }}
              </template>
            </Column>
            <Column
              :header="$t('mail_template.active')"
              sortable
              body-style="text-align:center"
              style="width: 45px"
              field="active"
              header-style=" width: 45px; text-align: center">
              <template #body="slotProps">
                <i v-if="slotProps.data.active" class="ga-icon ga-check_circle text-grey-900 text-2xl" />
                <i v-else class="ga-icon ga-close_circle text-red text-2xl" />
              </template>
            </Column>

            <Column body-style="text-align: right; overflow: visible" style="width: 220px">
              <template #body="slotProps">
                <div class="flex justify-end gap-2">
                  <span @click="openUpdateSidebar(slotProps.data)">
                    <i class="ga-icon ga-edit text-2xl text-grey-900 md:hover:cursor-pointer" />
                  </span>
                </div>
              </template>
            </Column>
          </AkDatatablePagination>
        </template>
      </GaListView>
    </template>
    <template #extra>
      <MailTemplateUpdate ref="mailTemplateUpdateSidebar" @updated="updateMailTemplate" />
    </template>
  </GaView>
</template>
